import React from "react";

// components
import ManagersControl from "./managersControl/ManagersControl";

const ManagersControls = ({ managers }) => {
  return managers.map((manager) => (
    <ManagersControl
      key={manager.user_id}
      id={manager.user_id}
      name={`${manager.first_name} ${manager.last_name}`}
      email={manager.email}
      phoneNumber={manager.phone_number}
    />
  ));
};

export default ManagersControls;
